function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkraineLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -5 310 310",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 16.904,
    y1: 219.298,
    x2: 70.077,
    y2: 166.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    style: {
      stopColor: "#f70202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#f80a0a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#f81617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#fa282a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#fb4042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#fd5c5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#ff7d81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7f83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.1 218.3c-2.6 0-4.9-.9-6.7-2.6-.7-.7-1.4-1.7-2.1-2.9l-15-36-15.2 36c-1 2.3-2.7 4-5.1 4.9-1.3.4-2.4.6-3.3.6-1.4 0-2.7-.3-3.9-.8-2.2-.9-3.8-2.6-4.9-5.1-.4-1.3-.6-2.5-.6-3.4 0-1.3.3-2.6.8-3.7l23.8-56.2c1.3-3 3.7-4.8 7.2-5.4h2.4c3.5.5 6 2.3 7.4 5.4l.1.5 23.1 55.7c.5 1.2.8 2.5.9 3.9 0 1.2-.2 2.3-.7 3.3-.9 2.5-2.6 4.2-4.9 5.1-.9.4-2.1.7-3.3.7z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 90.96,
    y1: 207.894,
    x2: 144.749,
    y2: 154.106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    style: {
      stopColor: "#f70202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#f80a0a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#f81617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#fa282a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#fb4042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#fd5c5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#ff7d81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7f83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91 207.9c-7.4-7.6-11.1-16.5-11.1-26.9 0-6.9 1.7-13.2 5.1-19.2 3.3-5.8 7.9-10.4 13.7-13.7 6-3.5 12.4-5.3 19.2-5.3 6.8 0 13.2 1.8 19.2 5.3 5.8 3.3 10.3 7.8 13.7 13.7 3.4 6 5.1 12.4 5.1 19.2 0 7.7-2.1 14.7-6.4 21.1-4.2 6.3-9.9 11-17.1 14-7 3-14.3 3.7-21.9 2.2-7.7-1.6-14.1-5-19.5-10.4zm46.7-26.8c0-5.3-1.9-10-5.8-14-3.8-3.8-8.5-5.7-14-5.7s-10.2 1.9-14 5.7c-3.7 3.7-5.7 8.4-5.8 14 0 5.6 1.9 10.3 5.7 14.1 3.8 3.8 8.5 5.7 14 5.7 5.6 0 10.3-1.9 14.1-5.7 3.9-3.9 5.8-8.6 5.8-14.1z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 163.393,
    y1: 196.449,
    x2: 214.438,
    y2: 145.405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    style: {
      stopColor: "#f70202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#f80a0a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#f81617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#fa282a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#fb4042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#fd5c5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#ff7d81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7f83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.9 218.3c-2.5 0-4.6-.9-6.2-2.6-1.6-1.6-2.5-3.7-2.5-6.3v-47.9h-11.6c-2.4 0-4.5-.9-6.2-2.6-1.8-1.8-2.6-3.9-2.6-6.4 0-2.5.9-4.6 2.7-6.4 1.7-1.7 3.8-2.6 6.2-2.6H209c2.4 0 4.5.9 6.3 2.7s2.7 3.9 2.7 6.4c0 2.4-.9 4.5-2.7 6.3-1.7 1.7-3.8 2.6-6.3 2.6h-11v47.9c0 2.4-.9 4.5-2.7 6.3-1.7 1.8-3.8 2.6-6.4 2.6z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 224.144,
    y1: 207.894,
    x2: 277.933,
    y2: 154.106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    style: {
      stopColor: "#f70202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#f80a0a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#f81617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#fa282a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#fb4042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    style: {
      stopColor: "#fd5c5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#ff7d81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff7f83"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 207.9c-7.4-7.6-11.1-16.5-11.1-26.9 0-6.9 1.7-13.2 5.1-19.2 3.3-5.8 7.9-10.4 13.7-13.7 6-3.5 12.4-5.3 19.2-5.3s13.2 1.8 19.2 5.3c5.8 3.3 10.3 7.8 13.7 13.7 3.4 6 5.1 12.4 5.1 19.2 0 7.7-2.1 14.7-6.4 21.1-4.2 6.3-9.9 11-17.1 14-7 3-14.3 3.7-21.9 2.2s-14.2-5-19.5-10.4zm46.7-26.8c0-5.3-1.9-10-5.8-14-3.8-3.8-8.5-5.7-14-5.7s-10.2 1.9-14 5.7c-3.7 3.7-5.7 8.4-5.8 14 0 5.6 1.9 10.3 5.7 14.1 3.8 3.8 8.5 5.7 14 5.7 5.6 0 10.3-1.9 14.1-5.7 3.8-3.9 5.8-8.6 5.8-14.1z",
    style: {
      fill: "url(#d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.2 265.4c-1.8 0-3.3.6-4.6 1.9-1.3 1.3-1.9 2.8-1.9 4.6 0 1.8.6 3.3 1.9 4.6 1.3 1.3 2.8 1.9 4.6 1.9 1.8 0 3.3-.6 4.7-1.9 1.2-1.2 1.8-2.7 1.8-4.6 0-1.7-.6-3.2-1.9-4.6-1.3-1.3-2.8-1.9-4.6-1.9z",
    style: {
      fill: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2 230.1H94.4c-4.8 0-8.8 3.9-8.8 8.8V286c0 4.8 3.9 8.8 8.8 8.8h110.8c4.8 0 8.8-3.9 8.8-8.8v-47.1c0-4.9-3.9-8.8-8.8-8.8zm-90 50.8c-2.6 2.6-5.6 3.9-9.2 3.9-3.6 0-6.6-1.3-9.2-3.9-2.5-2.5-3.8-5.6-3.8-9.1 0-2.4.6-4.7 1.9-6.7l9.3-17.7c.4-.7 1.1-1.2 1.9-1.5.3-.1.6-.1.7-.1.6 0 1.2.1 1.6.4 1 .6 1.5 1.4 1.6 2.5 0 .5-.2 1.1-.5 1.7l-4.6 8.5 1.1-.1c3.6 0 6.7 1.3 9.2 3.9 2.5 2.5 3.8 5.6 3.8 9.2-.1 3.5-1.3 6.5-3.8 9zm13.6-15.2c0 .5-.2 1-.5 1.3-.3.3-.8.5-1.3.5s-.9-.2-1.3-.6c-.4-.4-.6-.8-.6-1.3v-13.8c0-.6.2-1 .6-1.3.4-.4.9-.6 1.3-.6.5 0 1 .2 1.3.6.3.4.5.8.5 1.3v13.9zm-.3-18.2c-.4.4-.9.6-1.4.6-.6 0-1.1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4 0-.6.2-1.1.6-1.5.4-.4.9-.6 1.4-.6.6 0 1.1.2 1.4.6.4.4.6.9.6 1.5-.1.5-.2 1-.6 1.4zm15.7 18.6c-1 1-2.2 1.5-3.8 1.5h-3.2c-1.1 0-2.1-.3-3-.7-.9-.4-1.6-.9-2.1-1.6l-.1-.1c-.3-.4-.5-.8-.5-1.2 0-.5.2-1 .7-1.4.3-.2.7-.4 1.2-.4.6 0 1.1.2 1.4.7.4.6 1.2.9 2.2.9h3c.5 0 .9-.2 1.3-.5s.5-.8.5-1.3-.2-.9-.5-1.2c-.3-.3-.8-.5-1.3-.5h-2.7c-.6 0-1-.1-1.4-.4s-.5-.7-.5-1.2.2-.9.5-1.2c.4-.3.8-.5 1.4-.5h2.5c.5 0 .9-.2 1.2-.5.3-.3.5-.7.5-1.2s-.1-.8-.4-1.1c-.3-.3-.7-.4-1.2-.5h-2.6c-1.1.1-1.8.4-2.2.9-.4.5-.9.8-1.6.8-.4 0-.7-.1-.9-.3-.5-.4-.7-.8-.7-1.3v-.3c0-.4.1-.8.4-1.2.5-.7 1.2-1.2 2.2-1.6.9-.4 1.9-.7 3.1-.7h2.8c1.5 0 2.7.5 3.6 1.4.9.9 1.4 2.1 1.4 3.6s-.6 2.7-1.7 3.5c1.4.9 2.1 2.1 2 3.8 0 1.5-.5 2.7-1.5 3.8zm29 14.8c-2.7 2.6-6 4-9.7 4-2.5 0-4.9-.7-7.2-2-2.4-1.4-4.1-3.1-5.1-5.2-.3-.6-.5-1.2-.5-1.8 0-1 .5-1.7 1.4-2.3.5-.3 1.1-.4 1.6-.4.2 0 .4 0 .7.1.8.2 1.4.7 1.9 1.4l.1.2c.6 1.2 1.6 2.2 2.9 2.9 1.3.7 2.6 1.1 4.1 1.1 2.2 0 4-.7 5.4-2.2 1.5-1.5 2.2-3.3 2.2-5.4 0-2-.7-3.6-2.2-4.8-1.4-1.1-3.2-1.7-5.5-1.7h-2.8v-.1c-.8 0-1.4-.3-2-.8-.6-.6-.8-1.3-.8-2.2 0-.8.3-1.5.9-2.1l8.2-7.8h-11.7c-.9 0-1.6-.3-2.2-.8-.6-.5-.9-1.2-.9-2s.3-1.5.9-2.2c.5-.6 1.2-.9 2.2-.9h18.7c1.3 0 2.2.7 2.6 2 .2.3.2.6.2 1.1 0 .8-.3 1.5-.9 2.1l-8.5 8.2c3 .8 5.3 2.2 7 4.2 1.8 2.1 2.7 4.7 2.7 7.7.3 3.8-1 7-3.7 9.7zm28.9 0c-2.6 2.6-5.6 3.9-9.2 3.9-3.6 0-6.6-1.3-9.2-3.9-2.5-2.5-3.8-5.6-3.8-9.1 0-2.4.6-4.7 1.9-6.7l9.3-17.7c.4-.7 1.1-1.2 1.9-1.5.3-.1.6-.1.7-.1.6 0 1.2.1 1.6.4 1 .6 1.5 1.4 1.6 2.5 0 .5-.2 1.1-.5 1.7l-4.6 8.5 1.1-.1c3.6 0 6.7 1.3 9.2 3.9 2.5 2.5 3.8 5.6 3.8 9.2 0 3.5-1.3 6.5-3.8 9z",
    style: {
      fill: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 265.4c-1.8 0-3.3.6-4.6 1.9-1.3 1.3-1.9 2.8-1.9 4.6 0 1.8.6 3.3 1.9 4.6 1.3 1.3 2.8 1.9 4.6 1.9 1.8 0 3.3-.6 4.7-1.9 1.2-1.2 1.8-2.7 1.8-4.6 0-1.7-.6-3.2-1.9-4.6-1.3-1.3-2.8-1.9-4.6-1.9z",
    style: {
      fill: "#f70000"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 2283.896,
    y1: -1462.848,
    x2: 2270.498,
    y2: -1413.358,
    gradientTransform: "matrix(.00525 1 -1 .00525 -1269.942 -2226.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    style: {
      stopColor: "#fb2023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    style: {
      stopColor: "#fe373d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff4046"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m152.6 66.5 46-26.7c13.2-21.9-19.8-37.7-31.5-7.9-7 17.8-13 31.3-14.3 34.1 0 0-.1 0-.2-.1v.6z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 2300.302,
    y1: -1462.553,
    x2: 2276.307,
    y2: -1416.269,
    gradientTransform: "matrix(.00525 1 -1 .00525 -1269.942 -2226.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff4046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    style: {
      stopColor: "#fe373d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    style: {
      stopColor: "#fb2023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    style: {
      stopColor: "#f70000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.3 39.9s0-.1.1-.1l-45.9 26.7.5.1v-.1c3.3-.1 19.8-.2 36.7 4.6 30.5 8.7 34.7-33.9 8.6-31.2z",
    style: {
      fill: "url(#f)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 1282.397,
    y1: -3538.258,
    x2: 1268.998,
    y2: -3488.768,
    gradientTransform: "rotate(178.883 708.328 -1715.211) scale(.99999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    style: {
      stopColor: "#fb2023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    style: {
      stopColor: "#fe373d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff4046"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m152.6 66.5 27.3 45.6c22.1 12.9 37.4-20.3 7.5-31.6-17.9-6.7-31.5-12.6-34.3-13.8 0 0 0-.1.1-.2h-.6z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 1298.802,
    y1: -3537.963,
    x2: 1274.807,
    y2: -3491.679,
    gradientTransform: "rotate(178.883 708.328 -1715.211) scale(.99999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff4046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    style: {
      stopColor: "#fe373d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    style: {
      stopColor: "#fb2023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    style: {
      stopColor: "#f70000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.8 111.9s.1 0 .1.1l-27.4-45.5-.1.5h.1c.1 3.3.5 19.8-4.1 36.8-8.2 30.6 34.4 34.2 31.4 8.1z",
    style: {
      fill: "url(#h)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: -285.971,
    y1: -2318.197,
    x2: -337.234,
    y2: -2319.143,
    gradientTransform: "rotate(-90.057 1120.183 -1324.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff4042"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    style: {
      stopColor: "#fe3739"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    style: {
      stopColor: "#fb1f1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    style: {
      stopColor: "#f70000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.1 66.3 106 92.8c-13.3 21.8 19.6 37.7 31.4 8 7.1-17.8 13.1-31.2 14.4-34.1 0 0 .1 0 .2.1l.1-.5z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: -262.25,
    y1: -2328.504,
    x2: -312.319,
    y2: -2316.148,
    gradientTransform: "rotate(-90.057 1120.183 -1324.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#fb1c1e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    style: {
      stopColor: "#fd3034"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    style: {
      stopColor: "#fe3c41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff4045"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 92.7s0 .1-.1.1l46-26.5-.5-.1v.1c-3.3.1-19.8.1-36.7-4.7-30.4-8.8-34.7 33.7-8.7 31.1z",
    style: {
      fill: "url(#j)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 136.146,
    y1: 14.045,
    x2: 122.748,
    y2: 63.535
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    style: {
      stopColor: "#f70000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    style: {
      stopColor: "#fb2023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    style: {
      stopColor: "#fe373d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff4046"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m152.3 66.4-26.4-46.2C104 7 88.1 39.9 117.8 51.7c17.8 7.1 31.2 13.2 34 14.5 0 0 0 .1-.1.2h.6z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 152.551,
    y1: 14.34,
    x2: 128.557,
    y2: 60.624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff4046"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    style: {
      stopColor: "#fe373d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    style: {
      stopColor: "#fb2023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    style: {
      stopColor: "#f70000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126 20.6s-.1 0-.1-.1l26.5 46 .1-.5h-.1c-.1-3.3-.1-19.8 4.8-36.7 8.7-30.5-33.8-34.8-31.2-8.7z",
    style: {
      fill: "url(#l)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.3 110.2c-.8-.3-2.1 6.2-8.9 11.4-3.9 2.9-7 3.4-7.1 5.5-.2 2.4 3.7 5.6 6.9 5.2 7.3-1 10.6-21.5 9.1-22.1z",
    style: {
      fill: "#f70000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkraineLotto);
export default __webpack_public_path__ + "static/media/ukraine_lotto.56519d2df3ec86bbd36f839c5ba97def.svg";
export { ForwardRef as ReactComponent };